// constants
import { MainBannerActionTypes } from "./constants";

export interface MainBannerActionType {
  type:
    | MainBannerActionTypes.API_RESPONSE_SUCCESS
    | MainBannerActionTypes.API_RESPONSE_ERROR
    | MainBannerActionTypes.CREATE_MAIN_BANNER
    | MainBannerActionTypes.UPDATE_MAIN_BANNER
    | MainBannerActionTypes.GET_MAIN_BANNER
    | MainBannerActionTypes.DELETE_MAIN_BANNER;
  payload: {} | string;
}

// interface whoAreWeDetails {
//   id: string;
//   experience: string;
//   users: string;
//   courses: string;
// }

// common success
export const mainBannerApiResponseSuccess = (
  actionType: string,
  data: any | {}
): MainBannerActionType => ({
  type: MainBannerActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const mainBannerApiResponseError = (
  actionType: string,
  error: string
): MainBannerActionType => ({
  type: MainBannerActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createMainbanner = (
  head: string,
  head_ar: string,
  subhead: string,
  subhead_ar: string,
  title_text: string,
  title_text_ar: string,
  file: any
): MainBannerActionType => ({
  type: MainBannerActionTypes.CREATE_MAIN_BANNER,
  payload: {
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
    title_text,
    title_text_ar,
  },
});

export const getMainBanner = (): MainBannerActionType => ({
  type: MainBannerActionTypes.GET_MAIN_BANNER,
  payload: {},
});

export const deleteMainBanner = (id: string): MainBannerActionType => ({
  type: MainBannerActionTypes.DELETE_MAIN_BANNER,
  payload: { id },
});
export const updateMainBanner = (
  id: string,
  head: string,
  head_ar: string,
  subhead: string,
  subhead_ar: string,
  title_text: string,
  title_text_ar: string,
  file: any
): MainBannerActionType => ({
  type: MainBannerActionTypes.UPDATE_MAIN_BANNER,
  payload: {
    id,
    file,
    head,
    subhead,
    head_ar,
    subhead_ar,
    title_text,
    title_text_ar,
  },
});
